import React from "react";
import "./QAService.scss";
import {SubmitInfo} from "../../../../components/SubmitInfo/SubmitInfo";
import {BlackModal} from "../../../../components/BlackModal/BlackModal";
import {FooterFixed} from "../../../../components/FooterFixed";
import Tooth from "./tooth.jpg";
import {useFixedHeader} from "../../../../utils/headerHelper";
import intl from "react-intl-universal";

export function QAService() {
    useFixedHeader();

    return (
        <>
            <main className="main-content">
                <header
                    className="page-header large image-background qa-header-bg dark-color center no-padding"
                    data-stellar-background-ratio="0.3">
                    <div className="mask">
                        <div className="container v-align-center">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="x-large">{intl.get('cjwt')}</h1>
                                    <div>
                                        <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                        className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                        className="icon-glyph-10 medium"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <section className="pt-medium pb-medium light-color">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <div className="post-pic text-center">
                                        <img src={Tooth}
                                                                      className="responsive"/>
                                    </div>
                                    <h2>{intl.get('qa1')}</h2>
                                    <p className="font-16">
                                        {intl.get('qa1-detail')}<br/>
                                    </p>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <h2>{intl.get('qa2')}</h2>
                                    <p className="font-16">
                                        {intl.get('qa2-detail')}
                                    </p>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <h2>{intl.get('qa3')}</h2>
                                    <p className="font-16">
                                        {intl.get('qa3-detail')}
                                    </p>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <h2>{intl.get('qa4')}</h2>
                                    <p className="font-16">
                                        {intl.get('qa4-detail')}</p>
                                    <div className="row font-16">
                                        <div className="col-md-6">
                                            {intl.get('qa4-1')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-2')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-3')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-4')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-5')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-6')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-7')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa4-8')}
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <h2>{intl.get('qa5')}</h2>
                                    <p className="font-16">
                                        {intl.get('qa5-detail')}</p>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <h2>{intl.get('qa6')}</h2>
                                    <p className="font-16">
                                        {intl.get('qa6-detail')}
                                    </p>
                                </article>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <article className="post mb-medium">
                                    <h2>{intl.get('qa7')}</h2>
                                    <p className="font-16"></p>
                                    <div className="row font-16">
                                        <div className="col-md-6">
                                            {intl.get('qa7-1')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa7-2')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa7-3')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa7-4')}
                                        </div>

                                        <div className="col-md-6">
                                            {intl.get('qa7-5')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa7-6')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa7-7')}
                                        </div>
                                        <div className="col-md-6">
                                            {intl.get('qa7-8')}
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                </section>


                <SubmitInfo/>
                <BlackModal/>
            </main>
            <FooterFixed/>
        </>
    )
}
